// Stop event propagation
export const stopPropagation = <T>(fn?: (e: React.MouseEvent<T>) => void) => (e: React.MouseEvent<T>) => {
  e.stopPropagation();
  fn?.(e);
};

// Prevent default action
export const preventDefault = <T>(fn?: (e: React.MouseEvent<T>) => void) => (e: React.MouseEvent<T>) => {
  e.preventDefault();
  fn?.(e);
};

// Stop propagation and prevent default action
export const stopPropagationPreventDefault = <T>(fn: (e: React.MouseEvent<T>) => void) => (e: React.MouseEvent<T>) => {
  e.stopPropagation();
  e.preventDefault();
  fn(e);
};

// Stop propagation and prevent default action
export const stopPropagationPreventDefaultNoFn = (e: React.MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();
};
